/// <amd-module name="VSSUI/Components/Accordion/Accordion" />
import * as React from "react";
import { CSSTransitionGroup } from "react-transition-group";
import { getId } from "VSS/Core/Util/Object";
import { Button } from "VSSUI/Button";
import { Icon } from "VSSUI/Icon";
import { Observer } from "VSSUI/Observer";
import { Tooltip } from "VSSUI/TooltipEx";
import { css, getSafeId } from "VSSUI/Util";
import { IAccordionProps, IAccordionSection } from "./Accordion.Props";

export class Accordion extends React.Component<IAccordionProps, {}> {
    private controlId: string;

    constructor(props: IAccordionProps) {
        super(props);

        this.controlId = getId("accordion-section-group-content");
    }

    public render(): JSX.Element {
        return (
            <div className={css("bolt-accordion-section-group", this.props.className)}>
                <Observer sections={this.props.sections}>
                    {(sectionProps: { sections: IAccordionSection[] }) => {
                        return sectionProps.sections.map((s, index) => this.renderSection(s, index));
                    }}
                </Observer>
            </div>
        );
    }

    public renderSection(section: IAccordionSection, index: number): JSX.Element {
        const itemId = this.controlId + "-" + index;

        return (
            <Observer key={section.key} isCollapsed={section.isCollapsed}>
                {(props: { isCollapsed: boolean }) => {
                    return (
                        <div>
                            <span className="flex-row">
                                <Button
                                    subtle={true}
                                    onClick={event => {
                                        section.onClick && section.onClick(event);
                                        if (!event.isDefaultPrevented()) {
                                            this.props.onSectionClicked && this.props.onSectionClicked(event, section);
                                        }
                                    }}
                                    className="bolt-accordion-section-header flex-grow"
                                    ariaExpanded={!props.isCollapsed}
                                    ariaControls={!props.isCollapsed ? itemId : undefined}
                                >
                                    <span className="bolt-accordion-section-header-content flex-row flex-grow">
                                        <Tooltip overflowOnly>
                                            <div className="body-m font-weight-semibold flex-grow text-ellipsis">{section.title || section.key}</div>
                                        </Tooltip>
                                        <Icon
                                            iconName={"ChevronDownMed"}
                                            className={css("bolt-accordion-section-chevron", !props.isCollapsed && "rotate")}
                                        />
                                    </span>
                                </Button>
                            </span>
                            <CSSTransitionGroup
                                transitionName={"bolt-accordion-section-content"}
                                transitionEnter={true}
                                transitionLeave={true}
                                transitionEnterTimeout={150}
                                transitionLeaveTimeout={150}
                            >
                                {!props.isCollapsed && (
                                    <div id={getSafeId(itemId)} className={"bolt-accordion-section-content"}>
                                        {section.onRenderContent()}
                                    </div>
                                )}
                            </CSSTransitionGroup>
                        </div>
                    );
                }}
            </Observer>
        );
    }
}
